/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TermosRouteImport } from './routes/termos'
import { Route as TerapeutasRouteImport } from './routes/terapeutas'
import { Route as SolucaoRouteImport } from './routes/solucao'
import { Route as RegisterRouteImport } from './routes/register'
import { Route as PrivacidadeRouteImport } from './routes/privacidade'
import { Route as ParaTerapeutasRouteImport } from './routes/para-terapeutas'
import { Route as LoginRouteImport } from './routes/login'
import { Route as EspecialidadesRouteImport } from './routes/especialidades'
import { Route as DashboardRouteImport } from './routes/dashboard'
import { Route as ContabilidadeTerapeutasRouteImport } from './routes/contabilidade-terapeutas'
import { Route as ComoFuncionaRouteImport } from './routes/como-funciona'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as IndexRouteImport } from './routes/index'
import { Route as TerapeutasIndexRouteImport } from './routes/terapeutas.index'
import { Route as EspecialidadesIndexRouteImport } from './routes/especialidades.index'
import { Route as DashboardIndexRouteImport } from './routes/dashboard.index'
import { Route as AdminIndexRouteImport } from './routes/admin.index'
import { Route as TerapeutasIdRouteImport } from './routes/terapeutas.$id'
import { Route as SessaoConfirmadaRouteImport } from './routes/sessao.confirmada'
import { Route as PagamentoPaymentIdRouteImport } from './routes/pagamento.$paymentId'
import { Route as OnboardingTherapistRouteImport } from './routes/onboarding.therapist'
import { Route as OnboardingClientRouteImport } from './routes/onboarding.client'
import { Route as GruposIdRouteImport } from './routes/grupos.$id'
import { Route as EspecialidadesSlugRouteImport } from './routes/especialidades.$slug'
import { Route as DashboardSessoesRouteImport } from './routes/dashboard.sessoes'
import { Route as DashboardRelatoriosRouteImport } from './routes/dashboard.relatorios'
import { Route as DashboardPlanoRouteImport } from './routes/dashboard.plano'
import { Route as DashboardPerfilRouteImport } from './routes/dashboard.perfil'
import { Route as DashboardMensagensRouteImport } from './routes/dashboard.mensagens'
import { Route as DashboardIndicacoesRouteImport } from './routes/dashboard.indicacoes'
import { Route as DashboardGruposRouteImport } from './routes/dashboard.grupos'
import { Route as DashboardFinanceiroRouteImport } from './routes/dashboard.financeiro'
import { Route as DashboardContabilidadeRouteImport } from './routes/dashboard.contabilidade'
import { Route as DashboardClientesRouteImport } from './routes/dashboard.clientes'
import { Route as DashboardAgendaRouteImport } from './routes/dashboard.agenda'
import { Route as ConviteTokenRouteImport } from './routes/convite.$token'
import { Route as AuthCallbackRouteImport } from './routes/auth.callback'
import { Route as AdminTerapeutasRouteImport } from './routes/admin.terapeutas'
import { Route as AdminSuporteRouteImport } from './routes/admin.suporte'
import { Route as AdminSessoesRouteImport } from './routes/admin.sessoes'
import { Route as AdminRoadmapRouteImport } from './routes/admin.roadmap'
import { Route as AdminRepasseRouteImport } from './routes/admin.repasse'
import { Route as AdminNotasFiscaisRouteImport } from './routes/admin.notas-fiscais'
import { Route as AdminLeadsRouteImport } from './routes/admin.leads'
import { Route as AdminFuncionalidadesRouteImport } from './routes/admin.funcionalidades'
import { Route as AdminFinanceiroRouteImport } from './routes/admin.financeiro'
import { Route as AdminExtratoRouteImport } from './routes/admin.extrato'
import { Route as AdminClientesRouteImport } from './routes/admin.clientes'
import { Route as AdminCancelamentosRouteImport } from './routes/admin.cancelamentos'
import { Route as AdminBiRouteImport } from './routes/admin.bi'
import { Route as AdminAvaliacoesRouteImport } from './routes/admin.avaliacoes'
import { Route as TerapeutasIdIndexRouteImport } from './routes/terapeutas.$id.index'
import { Route as DashboardSessoesIndexRouteImport } from './routes/dashboard.sessoes.index'
import { Route as DashboardMensagensIndexRouteImport } from './routes/dashboard.mensagens.index'
import { Route as AdminTerapeutasIndexRouteImport } from './routes/admin.terapeutas.index'
import { Route as AdminSuporteIndexRouteImport } from './routes/admin.suporte.index'
import { Route as AdminClientesIndexRouteImport } from './routes/admin.clientes.index'
import { Route as TerapeutasIdAgendarRouteImport } from './routes/terapeutas.$id.agendar'
import { Route as SessaoAbrirTokenRouteImport } from './routes/sessao.abrir.$token'
import { Route as DashboardSessoesRecorrenciasRouteImport } from './routes/dashboard.sessoes.recorrencias'
import { Route as DashboardSessoesIdRouteImport } from './routes/dashboard.sessoes.$id'
import { Route as DashboardProntuariosClientIdRouteImport } from './routes/dashboard.prontuarios.$clientId'
import { Route as DashboardMensagensThreadRouteImport } from './routes/dashboard.mensagens.thread'
import { Route as DashboardMensagensNovoRouteImport } from './routes/dashboard.mensagens.novo'
import { Route as AdminTerapeutasIdRouteImport } from './routes/admin.terapeutas.$id'
import { Route as AdminSuporteUserIdRouteImport } from './routes/admin.suporte.$userId'
import { Route as AdminClientesIdRouteImport } from './routes/admin.clientes.$id'
import { Route as DashboardSessoesRecorrenciasIndexRouteImport } from './routes/dashboard.sessoes.recorrencias.index'
import { Route as DashboardSessoesRecorrenciasIdRouteImport } from './routes/dashboard.sessoes.recorrencias.$id'
import { Route as DashboardSessoesRecorrenciaNovaRouteImport } from './routes/dashboard.sessoes.recorrencia.nova'

const TermosRoute = TermosRouteImport.update({
  id: '/termos',
  path: '/termos',
  getParentRoute: () => rootRouteImport,
} as any)
const TerapeutasRoute = TerapeutasRouteImport.update({
  id: '/terapeutas',
  path: '/terapeutas',
  getParentRoute: () => rootRouteImport,
} as any)
const SolucaoRoute = SolucaoRouteImport.update({
  id: '/solucao',
  path: '/solucao',
  getParentRoute: () => rootRouteImport,
} as any)
const RegisterRoute = RegisterRouteImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacidadeRoute = PrivacidadeRouteImport.update({
  id: '/privacidade',
  path: '/privacidade',
  getParentRoute: () => rootRouteImport,
} as any)
const ParaTerapeutasRoute = ParaTerapeutasRouteImport.update({
  id: '/para-terapeutas',
  path: '/para-terapeutas',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const EspecialidadesRoute = EspecialidadesRouteImport.update({
  id: '/especialidades',
  path: '/especialidades',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardRoute = DashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const ContabilidadeTerapeutasRoute = ContabilidadeTerapeutasRouteImport.update({
  id: '/contabilidade-terapeutas',
  path: '/contabilidade-terapeutas',
  getParentRoute: () => rootRouteImport,
} as any)
const ComoFuncionaRoute = ComoFuncionaRouteImport.update({
  id: '/como-funciona',
  path: '/como-funciona',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRoute = AdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const TerapeutasIndexRoute = TerapeutasIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => TerapeutasRoute,
} as any)
const EspecialidadesIndexRoute = EspecialidadesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => EspecialidadesRoute,
} as any)
const DashboardIndexRoute = DashboardIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DashboardRoute,
} as any)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminRoute,
} as any)
const TerapeutasIdRoute = TerapeutasIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => TerapeutasRoute,
} as any)
const SessaoConfirmadaRoute = SessaoConfirmadaRouteImport.update({
  id: '/sessao/confirmada',
  path: '/sessao/confirmada',
  getParentRoute: () => rootRouteImport,
} as any)
const PagamentoPaymentIdRoute = PagamentoPaymentIdRouteImport.update({
  id: '/pagamento/$paymentId',
  path: '/pagamento/$paymentId',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingTherapistRoute = OnboardingTherapistRouteImport.update({
  id: '/onboarding/therapist',
  path: '/onboarding/therapist',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingClientRoute = OnboardingClientRouteImport.update({
  id: '/onboarding/client',
  path: '/onboarding/client',
  getParentRoute: () => rootRouteImport,
} as any)
const GruposIdRoute = GruposIdRouteImport.update({
  id: '/grupos/$id',
  path: '/grupos/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const EspecialidadesSlugRoute = EspecialidadesSlugRouteImport.update({
  id: '/$slug',
  path: '/$slug',
  getParentRoute: () => EspecialidadesRoute,
} as any)
const DashboardSessoesRoute = DashboardSessoesRouteImport.update({
  id: '/sessoes',
  path: '/sessoes',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardRelatoriosRoute = DashboardRelatoriosRouteImport.update({
  id: '/relatorios',
  path: '/relatorios',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardPlanoRoute = DashboardPlanoRouteImport.update({
  id: '/plano',
  path: '/plano',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardPerfilRoute = DashboardPerfilRouteImport.update({
  id: '/perfil',
  path: '/perfil',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardMensagensRoute = DashboardMensagensRouteImport.update({
  id: '/mensagens',
  path: '/mensagens',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardIndicacoesRoute = DashboardIndicacoesRouteImport.update({
  id: '/indicacoes',
  path: '/indicacoes',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardGruposRoute = DashboardGruposRouteImport.update({
  id: '/grupos',
  path: '/grupos',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardFinanceiroRoute = DashboardFinanceiroRouteImport.update({
  id: '/financeiro',
  path: '/financeiro',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardContabilidadeRoute = DashboardContabilidadeRouteImport.update({
  id: '/contabilidade',
  path: '/contabilidade',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardClientesRoute = DashboardClientesRouteImport.update({
  id: '/clientes',
  path: '/clientes',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardAgendaRoute = DashboardAgendaRouteImport.update({
  id: '/agenda',
  path: '/agenda',
  getParentRoute: () => DashboardRoute,
} as any)
const ConviteTokenRoute = ConviteTokenRouteImport.update({
  id: '/convite/$token',
  path: '/convite/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthCallbackRoute = AuthCallbackRouteImport.update({
  id: '/auth/callback',
  path: '/auth/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminTerapeutasRoute = AdminTerapeutasRouteImport.update({
  id: '/terapeutas',
  path: '/terapeutas',
  getParentRoute: () => AdminRoute,
} as any)
const AdminSuporteRoute = AdminSuporteRouteImport.update({
  id: '/suporte',
  path: '/suporte',
  getParentRoute: () => AdminRoute,
} as any)
const AdminSessoesRoute = AdminSessoesRouteImport.update({
  id: '/sessoes',
  path: '/sessoes',
  getParentRoute: () => AdminRoute,
} as any)
const AdminRoadmapRoute = AdminRoadmapRouteImport.update({
  id: '/roadmap',
  path: '/roadmap',
  getParentRoute: () => AdminRoute,
} as any)
const AdminRepasseRoute = AdminRepasseRouteImport.update({
  id: '/repasse',
  path: '/repasse',
  getParentRoute: () => AdminRoute,
} as any)
const AdminNotasFiscaisRoute = AdminNotasFiscaisRouteImport.update({
  id: '/notas-fiscais',
  path: '/notas-fiscais',
  getParentRoute: () => AdminRoute,
} as any)
const AdminLeadsRoute = AdminLeadsRouteImport.update({
  id: '/leads',
  path: '/leads',
  getParentRoute: () => AdminRoute,
} as any)
const AdminFuncionalidadesRoute = AdminFuncionalidadesRouteImport.update({
  id: '/funcionalidades',
  path: '/funcionalidades',
  getParentRoute: () => AdminRoute,
} as any)
const AdminFinanceiroRoute = AdminFinanceiroRouteImport.update({
  id: '/financeiro',
  path: '/financeiro',
  getParentRoute: () => AdminRoute,
} as any)
const AdminExtratoRoute = AdminExtratoRouteImport.update({
  id: '/extrato',
  path: '/extrato',
  getParentRoute: () => AdminRoute,
} as any)
const AdminClientesRoute = AdminClientesRouteImport.update({
  id: '/clientes',
  path: '/clientes',
  getParentRoute: () => AdminRoute,
} as any)
const AdminCancelamentosRoute = AdminCancelamentosRouteImport.update({
  id: '/cancelamentos',
  path: '/cancelamentos',
  getParentRoute: () => AdminRoute,
} as any)
const AdminBiRoute = AdminBiRouteImport.update({
  id: '/bi',
  path: '/bi',
  getParentRoute: () => AdminRoute,
} as any)
const AdminAvaliacoesRoute = AdminAvaliacoesRouteImport.update({
  id: '/avaliacoes',
  path: '/avaliacoes',
  getParentRoute: () => AdminRoute,
} as any)
const TerapeutasIdIndexRoute = TerapeutasIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => TerapeutasIdRoute,
} as any)
const DashboardSessoesIndexRoute = DashboardSessoesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DashboardSessoesRoute,
} as any)
const DashboardMensagensIndexRoute = DashboardMensagensIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DashboardMensagensRoute,
} as any)
const AdminTerapeutasIndexRoute = AdminTerapeutasIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminTerapeutasRoute,
} as any)
const AdminSuporteIndexRoute = AdminSuporteIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminSuporteRoute,
} as any)
const AdminClientesIndexRoute = AdminClientesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminClientesRoute,
} as any)
const TerapeutasIdAgendarRoute = TerapeutasIdAgendarRouteImport.update({
  id: '/agendar',
  path: '/agendar',
  getParentRoute: () => TerapeutasIdRoute,
} as any)
const SessaoAbrirTokenRoute = SessaoAbrirTokenRouteImport.update({
  id: '/sessao/abrir/$token',
  path: '/sessao/abrir/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardSessoesRecorrenciasRoute =
  DashboardSessoesRecorrenciasRouteImport.update({
    id: '/recorrencias',
    path: '/recorrencias',
    getParentRoute: () => DashboardSessoesRoute,
  } as any)
const DashboardSessoesIdRoute = DashboardSessoesIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => DashboardSessoesRoute,
} as any)
const DashboardProntuariosClientIdRoute =
  DashboardProntuariosClientIdRouteImport.update({
    id: '/prontuarios/$clientId',
    path: '/prontuarios/$clientId',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardMensagensThreadRoute =
  DashboardMensagensThreadRouteImport.update({
    id: '/thread',
    path: '/thread',
    getParentRoute: () => DashboardMensagensRoute,
  } as any)
const DashboardMensagensNovoRoute = DashboardMensagensNovoRouteImport.update({
  id: '/novo',
  path: '/novo',
  getParentRoute: () => DashboardMensagensRoute,
} as any)
const AdminTerapeutasIdRoute = AdminTerapeutasIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AdminTerapeutasRoute,
} as any)
const AdminSuporteUserIdRoute = AdminSuporteUserIdRouteImport.update({
  id: '/$userId',
  path: '/$userId',
  getParentRoute: () => AdminSuporteRoute,
} as any)
const AdminClientesIdRoute = AdminClientesIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AdminClientesRoute,
} as any)
const DashboardSessoesRecorrenciasIndexRoute =
  DashboardSessoesRecorrenciasIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DashboardSessoesRecorrenciasRoute,
  } as any)
const DashboardSessoesRecorrenciasIdRoute =
  DashboardSessoesRecorrenciasIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => DashboardSessoesRecorrenciasRoute,
  } as any)
const DashboardSessoesRecorrenciaNovaRoute =
  DashboardSessoesRecorrenciaNovaRouteImport.update({
    id: '/recorrencia/nova',
    path: '/recorrencia/nova',
    getParentRoute: () => DashboardSessoesRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteWithChildren
  '/como-funciona': typeof ComoFuncionaRoute
  '/contabilidade-terapeutas': typeof ContabilidadeTerapeutasRoute
  '/dashboard': typeof DashboardRouteWithChildren
  '/especialidades': typeof EspecialidadesRouteWithChildren
  '/login': typeof LoginRoute
  '/para-terapeutas': typeof ParaTerapeutasRoute
  '/privacidade': typeof PrivacidadeRoute
  '/register': typeof RegisterRoute
  '/solucao': typeof SolucaoRoute
  '/terapeutas': typeof TerapeutasRouteWithChildren
  '/termos': typeof TermosRoute
  '/admin/avaliacoes': typeof AdminAvaliacoesRoute
  '/admin/bi': typeof AdminBiRoute
  '/admin/cancelamentos': typeof AdminCancelamentosRoute
  '/admin/clientes': typeof AdminClientesRouteWithChildren
  '/admin/extrato': typeof AdminExtratoRoute
  '/admin/financeiro': typeof AdminFinanceiroRoute
  '/admin/funcionalidades': typeof AdminFuncionalidadesRoute
  '/admin/leads': typeof AdminLeadsRoute
  '/admin/notas-fiscais': typeof AdminNotasFiscaisRoute
  '/admin/repasse': typeof AdminRepasseRoute
  '/admin/roadmap': typeof AdminRoadmapRoute
  '/admin/sessoes': typeof AdminSessoesRoute
  '/admin/suporte': typeof AdminSuporteRouteWithChildren
  '/admin/terapeutas': typeof AdminTerapeutasRouteWithChildren
  '/auth/callback': typeof AuthCallbackRoute
  '/convite/$token': typeof ConviteTokenRoute
  '/dashboard/agenda': typeof DashboardAgendaRoute
  '/dashboard/clientes': typeof DashboardClientesRoute
  '/dashboard/contabilidade': typeof DashboardContabilidadeRoute
  '/dashboard/financeiro': typeof DashboardFinanceiroRoute
  '/dashboard/grupos': typeof DashboardGruposRoute
  '/dashboard/indicacoes': typeof DashboardIndicacoesRoute
  '/dashboard/mensagens': typeof DashboardMensagensRouteWithChildren
  '/dashboard/perfil': typeof DashboardPerfilRoute
  '/dashboard/plano': typeof DashboardPlanoRoute
  '/dashboard/relatorios': typeof DashboardRelatoriosRoute
  '/dashboard/sessoes': typeof DashboardSessoesRouteWithChildren
  '/especialidades/$slug': typeof EspecialidadesSlugRoute
  '/grupos/$id': typeof GruposIdRoute
  '/onboarding/client': typeof OnboardingClientRoute
  '/onboarding/therapist': typeof OnboardingTherapistRoute
  '/pagamento/$paymentId': typeof PagamentoPaymentIdRoute
  '/sessao/confirmada': typeof SessaoConfirmadaRoute
  '/terapeutas/$id': typeof TerapeutasIdRouteWithChildren
  '/admin/': typeof AdminIndexRoute
  '/dashboard/': typeof DashboardIndexRoute
  '/especialidades/': typeof EspecialidadesIndexRoute
  '/terapeutas/': typeof TerapeutasIndexRoute
  '/admin/clientes/$id': typeof AdminClientesIdRoute
  '/admin/suporte/$userId': typeof AdminSuporteUserIdRoute
  '/admin/terapeutas/$id': typeof AdminTerapeutasIdRoute
  '/dashboard/mensagens/novo': typeof DashboardMensagensNovoRoute
  '/dashboard/mensagens/thread': typeof DashboardMensagensThreadRoute
  '/dashboard/prontuarios/$clientId': typeof DashboardProntuariosClientIdRoute
  '/dashboard/sessoes/$id': typeof DashboardSessoesIdRoute
  '/dashboard/sessoes/recorrencias': typeof DashboardSessoesRecorrenciasRouteWithChildren
  '/sessao/abrir/$token': typeof SessaoAbrirTokenRoute
  '/terapeutas/$id/agendar': typeof TerapeutasIdAgendarRoute
  '/admin/clientes/': typeof AdminClientesIndexRoute
  '/admin/suporte/': typeof AdminSuporteIndexRoute
  '/admin/terapeutas/': typeof AdminTerapeutasIndexRoute
  '/dashboard/mensagens/': typeof DashboardMensagensIndexRoute
  '/dashboard/sessoes/': typeof DashboardSessoesIndexRoute
  '/terapeutas/$id/': typeof TerapeutasIdIndexRoute
  '/dashboard/sessoes/recorrencia/nova': typeof DashboardSessoesRecorrenciaNovaRoute
  '/dashboard/sessoes/recorrencias/$id': typeof DashboardSessoesRecorrenciasIdRoute
  '/dashboard/sessoes/recorrencias/': typeof DashboardSessoesRecorrenciasIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/como-funciona': typeof ComoFuncionaRoute
  '/contabilidade-terapeutas': typeof ContabilidadeTerapeutasRoute
  '/login': typeof LoginRoute
  '/para-terapeutas': typeof ParaTerapeutasRoute
  '/privacidade': typeof PrivacidadeRoute
  '/register': typeof RegisterRoute
  '/solucao': typeof SolucaoRoute
  '/termos': typeof TermosRoute
  '/admin/avaliacoes': typeof AdminAvaliacoesRoute
  '/admin/bi': typeof AdminBiRoute
  '/admin/cancelamentos': typeof AdminCancelamentosRoute
  '/admin/extrato': typeof AdminExtratoRoute
  '/admin/financeiro': typeof AdminFinanceiroRoute
  '/admin/funcionalidades': typeof AdminFuncionalidadesRoute
  '/admin/leads': typeof AdminLeadsRoute
  '/admin/notas-fiscais': typeof AdminNotasFiscaisRoute
  '/admin/repasse': typeof AdminRepasseRoute
  '/admin/roadmap': typeof AdminRoadmapRoute
  '/admin/sessoes': typeof AdminSessoesRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/convite/$token': typeof ConviteTokenRoute
  '/dashboard/agenda': typeof DashboardAgendaRoute
  '/dashboard/clientes': typeof DashboardClientesRoute
  '/dashboard/contabilidade': typeof DashboardContabilidadeRoute
  '/dashboard/financeiro': typeof DashboardFinanceiroRoute
  '/dashboard/grupos': typeof DashboardGruposRoute
  '/dashboard/indicacoes': typeof DashboardIndicacoesRoute
  '/dashboard/perfil': typeof DashboardPerfilRoute
  '/dashboard/plano': typeof DashboardPlanoRoute
  '/dashboard/relatorios': typeof DashboardRelatoriosRoute
  '/especialidades/$slug': typeof EspecialidadesSlugRoute
  '/grupos/$id': typeof GruposIdRoute
  '/onboarding/client': typeof OnboardingClientRoute
  '/onboarding/therapist': typeof OnboardingTherapistRoute
  '/pagamento/$paymentId': typeof PagamentoPaymentIdRoute
  '/sessao/confirmada': typeof SessaoConfirmadaRoute
  '/admin': typeof AdminIndexRoute
  '/dashboard': typeof DashboardIndexRoute
  '/especialidades': typeof EspecialidadesIndexRoute
  '/terapeutas': typeof TerapeutasIndexRoute
  '/admin/clientes/$id': typeof AdminClientesIdRoute
  '/admin/suporte/$userId': typeof AdminSuporteUserIdRoute
  '/admin/terapeutas/$id': typeof AdminTerapeutasIdRoute
  '/dashboard/mensagens/novo': typeof DashboardMensagensNovoRoute
  '/dashboard/mensagens/thread': typeof DashboardMensagensThreadRoute
  '/dashboard/prontuarios/$clientId': typeof DashboardProntuariosClientIdRoute
  '/dashboard/sessoes/$id': typeof DashboardSessoesIdRoute
  '/sessao/abrir/$token': typeof SessaoAbrirTokenRoute
  '/terapeutas/$id/agendar': typeof TerapeutasIdAgendarRoute
  '/admin/clientes': typeof AdminClientesIndexRoute
  '/admin/suporte': typeof AdminSuporteIndexRoute
  '/admin/terapeutas': typeof AdminTerapeutasIndexRoute
  '/dashboard/mensagens': typeof DashboardMensagensIndexRoute
  '/dashboard/sessoes': typeof DashboardSessoesIndexRoute
  '/terapeutas/$id': typeof TerapeutasIdIndexRoute
  '/dashboard/sessoes/recorrencia/nova': typeof DashboardSessoesRecorrenciaNovaRoute
  '/dashboard/sessoes/recorrencias/$id': typeof DashboardSessoesRecorrenciasIdRoute
  '/dashboard/sessoes/recorrencias': typeof DashboardSessoesRecorrenciasIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteWithChildren
  '/como-funciona': typeof ComoFuncionaRoute
  '/contabilidade-terapeutas': typeof ContabilidadeTerapeutasRoute
  '/dashboard': typeof DashboardRouteWithChildren
  '/especialidades': typeof EspecialidadesRouteWithChildren
  '/login': typeof LoginRoute
  '/para-terapeutas': typeof ParaTerapeutasRoute
  '/privacidade': typeof PrivacidadeRoute
  '/register': typeof RegisterRoute
  '/solucao': typeof SolucaoRoute
  '/terapeutas': typeof TerapeutasRouteWithChildren
  '/termos': typeof TermosRoute
  '/admin/avaliacoes': typeof AdminAvaliacoesRoute
  '/admin/bi': typeof AdminBiRoute
  '/admin/cancelamentos': typeof AdminCancelamentosRoute
  '/admin/clientes': typeof AdminClientesRouteWithChildren
  '/admin/extrato': typeof AdminExtratoRoute
  '/admin/financeiro': typeof AdminFinanceiroRoute
  '/admin/funcionalidades': typeof AdminFuncionalidadesRoute
  '/admin/leads': typeof AdminLeadsRoute
  '/admin/notas-fiscais': typeof AdminNotasFiscaisRoute
  '/admin/repasse': typeof AdminRepasseRoute
  '/admin/roadmap': typeof AdminRoadmapRoute
  '/admin/sessoes': typeof AdminSessoesRoute
  '/admin/suporte': typeof AdminSuporteRouteWithChildren
  '/admin/terapeutas': typeof AdminTerapeutasRouteWithChildren
  '/auth/callback': typeof AuthCallbackRoute
  '/convite/$token': typeof ConviteTokenRoute
  '/dashboard/agenda': typeof DashboardAgendaRoute
  '/dashboard/clientes': typeof DashboardClientesRoute
  '/dashboard/contabilidade': typeof DashboardContabilidadeRoute
  '/dashboard/financeiro': typeof DashboardFinanceiroRoute
  '/dashboard/grupos': typeof DashboardGruposRoute
  '/dashboard/indicacoes': typeof DashboardIndicacoesRoute
  '/dashboard/mensagens': typeof DashboardMensagensRouteWithChildren
  '/dashboard/perfil': typeof DashboardPerfilRoute
  '/dashboard/plano': typeof DashboardPlanoRoute
  '/dashboard/relatorios': typeof DashboardRelatoriosRoute
  '/dashboard/sessoes': typeof DashboardSessoesRouteWithChildren
  '/especialidades/$slug': typeof EspecialidadesSlugRoute
  '/grupos/$id': typeof GruposIdRoute
  '/onboarding/client': typeof OnboardingClientRoute
  '/onboarding/therapist': typeof OnboardingTherapistRoute
  '/pagamento/$paymentId': typeof PagamentoPaymentIdRoute
  '/sessao/confirmada': typeof SessaoConfirmadaRoute
  '/terapeutas/$id': typeof TerapeutasIdRouteWithChildren
  '/admin/': typeof AdminIndexRoute
  '/dashboard/': typeof DashboardIndexRoute
  '/especialidades/': typeof EspecialidadesIndexRoute
  '/terapeutas/': typeof TerapeutasIndexRoute
  '/admin/clientes/$id': typeof AdminClientesIdRoute
  '/admin/suporte/$userId': typeof AdminSuporteUserIdRoute
  '/admin/terapeutas/$id': typeof AdminTerapeutasIdRoute
  '/dashboard/mensagens/novo': typeof DashboardMensagensNovoRoute
  '/dashboard/mensagens/thread': typeof DashboardMensagensThreadRoute
  '/dashboard/prontuarios/$clientId': typeof DashboardProntuariosClientIdRoute
  '/dashboard/sessoes/$id': typeof DashboardSessoesIdRoute
  '/dashboard/sessoes/recorrencias': typeof DashboardSessoesRecorrenciasRouteWithChildren
  '/sessao/abrir/$token': typeof SessaoAbrirTokenRoute
  '/terapeutas/$id/agendar': typeof TerapeutasIdAgendarRoute
  '/admin/clientes/': typeof AdminClientesIndexRoute
  '/admin/suporte/': typeof AdminSuporteIndexRoute
  '/admin/terapeutas/': typeof AdminTerapeutasIndexRoute
  '/dashboard/mensagens/': typeof DashboardMensagensIndexRoute
  '/dashboard/sessoes/': typeof DashboardSessoesIndexRoute
  '/terapeutas/$id/': typeof TerapeutasIdIndexRoute
  '/dashboard/sessoes/recorrencia/nova': typeof DashboardSessoesRecorrenciaNovaRoute
  '/dashboard/sessoes/recorrencias/$id': typeof DashboardSessoesRecorrenciasIdRoute
  '/dashboard/sessoes/recorrencias/': typeof DashboardSessoesRecorrenciasIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/admin'
    | '/como-funciona'
    | '/contabilidade-terapeutas'
    | '/dashboard'
    | '/especialidades'
    | '/login'
    | '/para-terapeutas'
    | '/privacidade'
    | '/register'
    | '/solucao'
    | '/terapeutas'
    | '/termos'
    | '/admin/avaliacoes'
    | '/admin/bi'
    | '/admin/cancelamentos'
    | '/admin/clientes'
    | '/admin/extrato'
    | '/admin/financeiro'
    | '/admin/funcionalidades'
    | '/admin/leads'
    | '/admin/notas-fiscais'
    | '/admin/repasse'
    | '/admin/roadmap'
    | '/admin/sessoes'
    | '/admin/suporte'
    | '/admin/terapeutas'
    | '/auth/callback'
    | '/convite/$token'
    | '/dashboard/agenda'
    | '/dashboard/clientes'
    | '/dashboard/contabilidade'
    | '/dashboard/financeiro'
    | '/dashboard/grupos'
    | '/dashboard/indicacoes'
    | '/dashboard/mensagens'
    | '/dashboard/perfil'
    | '/dashboard/plano'
    | '/dashboard/relatorios'
    | '/dashboard/sessoes'
    | '/especialidades/$slug'
    | '/grupos/$id'
    | '/onboarding/client'
    | '/onboarding/therapist'
    | '/pagamento/$paymentId'
    | '/sessao/confirmada'
    | '/terapeutas/$id'
    | '/admin/'
    | '/dashboard/'
    | '/especialidades/'
    | '/terapeutas/'
    | '/admin/clientes/$id'
    | '/admin/suporte/$userId'
    | '/admin/terapeutas/$id'
    | '/dashboard/mensagens/novo'
    | '/dashboard/mensagens/thread'
    | '/dashboard/prontuarios/$clientId'
    | '/dashboard/sessoes/$id'
    | '/dashboard/sessoes/recorrencias'
    | '/sessao/abrir/$token'
    | '/terapeutas/$id/agendar'
    | '/admin/clientes/'
    | '/admin/suporte/'
    | '/admin/terapeutas/'
    | '/dashboard/mensagens/'
    | '/dashboard/sessoes/'
    | '/terapeutas/$id/'
    | '/dashboard/sessoes/recorrencia/nova'
    | '/dashboard/sessoes/recorrencias/$id'
    | '/dashboard/sessoes/recorrencias/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/como-funciona'
    | '/contabilidade-terapeutas'
    | '/login'
    | '/para-terapeutas'
    | '/privacidade'
    | '/register'
    | '/solucao'
    | '/termos'
    | '/admin/avaliacoes'
    | '/admin/bi'
    | '/admin/cancelamentos'
    | '/admin/extrato'
    | '/admin/financeiro'
    | '/admin/funcionalidades'
    | '/admin/leads'
    | '/admin/notas-fiscais'
    | '/admin/repasse'
    | '/admin/roadmap'
    | '/admin/sessoes'
    | '/auth/callback'
    | '/convite/$token'
    | '/dashboard/agenda'
    | '/dashboard/clientes'
    | '/dashboard/contabilidade'
    | '/dashboard/financeiro'
    | '/dashboard/grupos'
    | '/dashboard/indicacoes'
    | '/dashboard/perfil'
    | '/dashboard/plano'
    | '/dashboard/relatorios'
    | '/especialidades/$slug'
    | '/grupos/$id'
    | '/onboarding/client'
    | '/onboarding/therapist'
    | '/pagamento/$paymentId'
    | '/sessao/confirmada'
    | '/admin'
    | '/dashboard'
    | '/especialidades'
    | '/terapeutas'
    | '/admin/clientes/$id'
    | '/admin/suporte/$userId'
    | '/admin/terapeutas/$id'
    | '/dashboard/mensagens/novo'
    | '/dashboard/mensagens/thread'
    | '/dashboard/prontuarios/$clientId'
    | '/dashboard/sessoes/$id'
    | '/sessao/abrir/$token'
    | '/terapeutas/$id/agendar'
    | '/admin/clientes'
    | '/admin/suporte'
    | '/admin/terapeutas'
    | '/dashboard/mensagens'
    | '/dashboard/sessoes'
    | '/terapeutas/$id'
    | '/dashboard/sessoes/recorrencia/nova'
    | '/dashboard/sessoes/recorrencias/$id'
    | '/dashboard/sessoes/recorrencias'
  id:
    | '__root__'
    | '/'
    | '/admin'
    | '/como-funciona'
    | '/contabilidade-terapeutas'
    | '/dashboard'
    | '/especialidades'
    | '/login'
    | '/para-terapeutas'
    | '/privacidade'
    | '/register'
    | '/solucao'
    | '/terapeutas'
    | '/termos'
    | '/admin/avaliacoes'
    | '/admin/bi'
    | '/admin/cancelamentos'
    | '/admin/clientes'
    | '/admin/extrato'
    | '/admin/financeiro'
    | '/admin/funcionalidades'
    | '/admin/leads'
    | '/admin/notas-fiscais'
    | '/admin/repasse'
    | '/admin/roadmap'
    | '/admin/sessoes'
    | '/admin/suporte'
    | '/admin/terapeutas'
    | '/auth/callback'
    | '/convite/$token'
    | '/dashboard/agenda'
    | '/dashboard/clientes'
    | '/dashboard/contabilidade'
    | '/dashboard/financeiro'
    | '/dashboard/grupos'
    | '/dashboard/indicacoes'
    | '/dashboard/mensagens'
    | '/dashboard/perfil'
    | '/dashboard/plano'
    | '/dashboard/relatorios'
    | '/dashboard/sessoes'
    | '/especialidades/$slug'
    | '/grupos/$id'
    | '/onboarding/client'
    | '/onboarding/therapist'
    | '/pagamento/$paymentId'
    | '/sessao/confirmada'
    | '/terapeutas/$id'
    | '/admin/'
    | '/dashboard/'
    | '/especialidades/'
    | '/terapeutas/'
    | '/admin/clientes/$id'
    | '/admin/suporte/$userId'
    | '/admin/terapeutas/$id'
    | '/dashboard/mensagens/novo'
    | '/dashboard/mensagens/thread'
    | '/dashboard/prontuarios/$clientId'
    | '/dashboard/sessoes/$id'
    | '/dashboard/sessoes/recorrencias'
    | '/sessao/abrir/$token'
    | '/terapeutas/$id/agendar'
    | '/admin/clientes/'
    | '/admin/suporte/'
    | '/admin/terapeutas/'
    | '/dashboard/mensagens/'
    | '/dashboard/sessoes/'
    | '/terapeutas/$id/'
    | '/dashboard/sessoes/recorrencia/nova'
    | '/dashboard/sessoes/recorrencias/$id'
    | '/dashboard/sessoes/recorrencias/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AdminRoute: typeof AdminRouteWithChildren
  ComoFuncionaRoute: typeof ComoFuncionaRoute
  ContabilidadeTerapeutasRoute: typeof ContabilidadeTerapeutasRoute
  DashboardRoute: typeof DashboardRouteWithChildren
  EspecialidadesRoute: typeof EspecialidadesRouteWithChildren
  LoginRoute: typeof LoginRoute
  ParaTerapeutasRoute: typeof ParaTerapeutasRoute
  PrivacidadeRoute: typeof PrivacidadeRoute
  RegisterRoute: typeof RegisterRoute
  SolucaoRoute: typeof SolucaoRoute
  TerapeutasRoute: typeof TerapeutasRouteWithChildren
  TermosRoute: typeof TermosRoute
  AuthCallbackRoute: typeof AuthCallbackRoute
  ConviteTokenRoute: typeof ConviteTokenRoute
  GruposIdRoute: typeof GruposIdRoute
  OnboardingClientRoute: typeof OnboardingClientRoute
  OnboardingTherapistRoute: typeof OnboardingTherapistRoute
  PagamentoPaymentIdRoute: typeof PagamentoPaymentIdRoute
  SessaoConfirmadaRoute: typeof SessaoConfirmadaRoute
  SessaoAbrirTokenRoute: typeof SessaoAbrirTokenRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/termos': {
      id: '/termos'
      path: '/termos'
      fullPath: '/termos'
      preLoaderRoute: typeof TermosRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/terapeutas': {
      id: '/terapeutas'
      path: '/terapeutas'
      fullPath: '/terapeutas'
      preLoaderRoute: typeof TerapeutasRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/solucao': {
      id: '/solucao'
      path: '/solucao'
      fullPath: '/solucao'
      preLoaderRoute: typeof SolucaoRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/register': {
      id: '/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof RegisterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacidade': {
      id: '/privacidade'
      path: '/privacidade'
      fullPath: '/privacidade'
      preLoaderRoute: typeof PrivacidadeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/para-terapeutas': {
      id: '/para-terapeutas'
      path: '/para-terapeutas'
      fullPath: '/para-terapeutas'
      preLoaderRoute: typeof ParaTerapeutasRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/especialidades': {
      id: '/especialidades'
      path: '/especialidades'
      fullPath: '/especialidades'
      preLoaderRoute: typeof EspecialidadesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard': {
      id: '/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/contabilidade-terapeutas': {
      id: '/contabilidade-terapeutas'
      path: '/contabilidade-terapeutas'
      fullPath: '/contabilidade-terapeutas'
      preLoaderRoute: typeof ContabilidadeTerapeutasRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/como-funciona': {
      id: '/como-funciona'
      path: '/como-funciona'
      fullPath: '/como-funciona'
      preLoaderRoute: typeof ComoFuncionaRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/terapeutas/': {
      id: '/terapeutas/'
      path: '/'
      fullPath: '/terapeutas/'
      preLoaderRoute: typeof TerapeutasIndexRouteImport
      parentRoute: typeof TerapeutasRoute
    }
    '/especialidades/': {
      id: '/especialidades/'
      path: '/'
      fullPath: '/especialidades/'
      preLoaderRoute: typeof EspecialidadesIndexRouteImport
      parentRoute: typeof EspecialidadesRoute
    }
    '/dashboard/': {
      id: '/dashboard/'
      path: '/'
      fullPath: '/dashboard/'
      preLoaderRoute: typeof DashboardIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/admin/': {
      id: '/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/terapeutas/$id': {
      id: '/terapeutas/$id'
      path: '/$id'
      fullPath: '/terapeutas/$id'
      preLoaderRoute: typeof TerapeutasIdRouteImport
      parentRoute: typeof TerapeutasRoute
    }
    '/sessao/confirmada': {
      id: '/sessao/confirmada'
      path: '/sessao/confirmada'
      fullPath: '/sessao/confirmada'
      preLoaderRoute: typeof SessaoConfirmadaRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pagamento/$paymentId': {
      id: '/pagamento/$paymentId'
      path: '/pagamento/$paymentId'
      fullPath: '/pagamento/$paymentId'
      preLoaderRoute: typeof PagamentoPaymentIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding/therapist': {
      id: '/onboarding/therapist'
      path: '/onboarding/therapist'
      fullPath: '/onboarding/therapist'
      preLoaderRoute: typeof OnboardingTherapistRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding/client': {
      id: '/onboarding/client'
      path: '/onboarding/client'
      fullPath: '/onboarding/client'
      preLoaderRoute: typeof OnboardingClientRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/grupos/$id': {
      id: '/grupos/$id'
      path: '/grupos/$id'
      fullPath: '/grupos/$id'
      preLoaderRoute: typeof GruposIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/especialidades/$slug': {
      id: '/especialidades/$slug'
      path: '/$slug'
      fullPath: '/especialidades/$slug'
      preLoaderRoute: typeof EspecialidadesSlugRouteImport
      parentRoute: typeof EspecialidadesRoute
    }
    '/dashboard/sessoes': {
      id: '/dashboard/sessoes'
      path: '/sessoes'
      fullPath: '/dashboard/sessoes'
      preLoaderRoute: typeof DashboardSessoesRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/relatorios': {
      id: '/dashboard/relatorios'
      path: '/relatorios'
      fullPath: '/dashboard/relatorios'
      preLoaderRoute: typeof DashboardRelatoriosRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/plano': {
      id: '/dashboard/plano'
      path: '/plano'
      fullPath: '/dashboard/plano'
      preLoaderRoute: typeof DashboardPlanoRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/perfil': {
      id: '/dashboard/perfil'
      path: '/perfil'
      fullPath: '/dashboard/perfil'
      preLoaderRoute: typeof DashboardPerfilRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/mensagens': {
      id: '/dashboard/mensagens'
      path: '/mensagens'
      fullPath: '/dashboard/mensagens'
      preLoaderRoute: typeof DashboardMensagensRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/indicacoes': {
      id: '/dashboard/indicacoes'
      path: '/indicacoes'
      fullPath: '/dashboard/indicacoes'
      preLoaderRoute: typeof DashboardIndicacoesRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/grupos': {
      id: '/dashboard/grupos'
      path: '/grupos'
      fullPath: '/dashboard/grupos'
      preLoaderRoute: typeof DashboardGruposRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/financeiro': {
      id: '/dashboard/financeiro'
      path: '/financeiro'
      fullPath: '/dashboard/financeiro'
      preLoaderRoute: typeof DashboardFinanceiroRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/contabilidade': {
      id: '/dashboard/contabilidade'
      path: '/contabilidade'
      fullPath: '/dashboard/contabilidade'
      preLoaderRoute: typeof DashboardContabilidadeRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/clientes': {
      id: '/dashboard/clientes'
      path: '/clientes'
      fullPath: '/dashboard/clientes'
      preLoaderRoute: typeof DashboardClientesRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/agenda': {
      id: '/dashboard/agenda'
      path: '/agenda'
      fullPath: '/dashboard/agenda'
      preLoaderRoute: typeof DashboardAgendaRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/convite/$token': {
      id: '/convite/$token'
      path: '/convite/$token'
      fullPath: '/convite/$token'
      preLoaderRoute: typeof ConviteTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/callback': {
      id: '/auth/callback'
      path: '/auth/callback'
      fullPath: '/auth/callback'
      preLoaderRoute: typeof AuthCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/terapeutas': {
      id: '/admin/terapeutas'
      path: '/terapeutas'
      fullPath: '/admin/terapeutas'
      preLoaderRoute: typeof AdminTerapeutasRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/suporte': {
      id: '/admin/suporte'
      path: '/suporte'
      fullPath: '/admin/suporte'
      preLoaderRoute: typeof AdminSuporteRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/sessoes': {
      id: '/admin/sessoes'
      path: '/sessoes'
      fullPath: '/admin/sessoes'
      preLoaderRoute: typeof AdminSessoesRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/roadmap': {
      id: '/admin/roadmap'
      path: '/roadmap'
      fullPath: '/admin/roadmap'
      preLoaderRoute: typeof AdminRoadmapRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/repasse': {
      id: '/admin/repasse'
      path: '/repasse'
      fullPath: '/admin/repasse'
      preLoaderRoute: typeof AdminRepasseRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/notas-fiscais': {
      id: '/admin/notas-fiscais'
      path: '/notas-fiscais'
      fullPath: '/admin/notas-fiscais'
      preLoaderRoute: typeof AdminNotasFiscaisRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/leads': {
      id: '/admin/leads'
      path: '/leads'
      fullPath: '/admin/leads'
      preLoaderRoute: typeof AdminLeadsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/funcionalidades': {
      id: '/admin/funcionalidades'
      path: '/funcionalidades'
      fullPath: '/admin/funcionalidades'
      preLoaderRoute: typeof AdminFuncionalidadesRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/financeiro': {
      id: '/admin/financeiro'
      path: '/financeiro'
      fullPath: '/admin/financeiro'
      preLoaderRoute: typeof AdminFinanceiroRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/extrato': {
      id: '/admin/extrato'
      path: '/extrato'
      fullPath: '/admin/extrato'
      preLoaderRoute: typeof AdminExtratoRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/clientes': {
      id: '/admin/clientes'
      path: '/clientes'
      fullPath: '/admin/clientes'
      preLoaderRoute: typeof AdminClientesRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/cancelamentos': {
      id: '/admin/cancelamentos'
      path: '/cancelamentos'
      fullPath: '/admin/cancelamentos'
      preLoaderRoute: typeof AdminCancelamentosRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/bi': {
      id: '/admin/bi'
      path: '/bi'
      fullPath: '/admin/bi'
      preLoaderRoute: typeof AdminBiRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/avaliacoes': {
      id: '/admin/avaliacoes'
      path: '/avaliacoes'
      fullPath: '/admin/avaliacoes'
      preLoaderRoute: typeof AdminAvaliacoesRouteImport
      parentRoute: typeof AdminRoute
    }
    '/terapeutas/$id/': {
      id: '/terapeutas/$id/'
      path: '/'
      fullPath: '/terapeutas/$id/'
      preLoaderRoute: typeof TerapeutasIdIndexRouteImport
      parentRoute: typeof TerapeutasIdRoute
    }
    '/dashboard/sessoes/': {
      id: '/dashboard/sessoes/'
      path: '/'
      fullPath: '/dashboard/sessoes/'
      preLoaderRoute: typeof DashboardSessoesIndexRouteImport
      parentRoute: typeof DashboardSessoesRoute
    }
    '/dashboard/mensagens/': {
      id: '/dashboard/mensagens/'
      path: '/'
      fullPath: '/dashboard/mensagens/'
      preLoaderRoute: typeof DashboardMensagensIndexRouteImport
      parentRoute: typeof DashboardMensagensRoute
    }
    '/admin/terapeutas/': {
      id: '/admin/terapeutas/'
      path: '/'
      fullPath: '/admin/terapeutas/'
      preLoaderRoute: typeof AdminTerapeutasIndexRouteImport
      parentRoute: typeof AdminTerapeutasRoute
    }
    '/admin/suporte/': {
      id: '/admin/suporte/'
      path: '/'
      fullPath: '/admin/suporte/'
      preLoaderRoute: typeof AdminSuporteIndexRouteImport
      parentRoute: typeof AdminSuporteRoute
    }
    '/admin/clientes/': {
      id: '/admin/clientes/'
      path: '/'
      fullPath: '/admin/clientes/'
      preLoaderRoute: typeof AdminClientesIndexRouteImport
      parentRoute: typeof AdminClientesRoute
    }
    '/terapeutas/$id/agendar': {
      id: '/terapeutas/$id/agendar'
      path: '/agendar'
      fullPath: '/terapeutas/$id/agendar'
      preLoaderRoute: typeof TerapeutasIdAgendarRouteImport
      parentRoute: typeof TerapeutasIdRoute
    }
    '/sessao/abrir/$token': {
      id: '/sessao/abrir/$token'
      path: '/sessao/abrir/$token'
      fullPath: '/sessao/abrir/$token'
      preLoaderRoute: typeof SessaoAbrirTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard/sessoes/recorrencias': {
      id: '/dashboard/sessoes/recorrencias'
      path: '/recorrencias'
      fullPath: '/dashboard/sessoes/recorrencias'
      preLoaderRoute: typeof DashboardSessoesRecorrenciasRouteImport
      parentRoute: typeof DashboardSessoesRoute
    }
    '/dashboard/sessoes/$id': {
      id: '/dashboard/sessoes/$id'
      path: '/$id'
      fullPath: '/dashboard/sessoes/$id'
      preLoaderRoute: typeof DashboardSessoesIdRouteImport
      parentRoute: typeof DashboardSessoesRoute
    }
    '/dashboard/prontuarios/$clientId': {
      id: '/dashboard/prontuarios/$clientId'
      path: '/prontuarios/$clientId'
      fullPath: '/dashboard/prontuarios/$clientId'
      preLoaderRoute: typeof DashboardProntuariosClientIdRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/mensagens/thread': {
      id: '/dashboard/mensagens/thread'
      path: '/thread'
      fullPath: '/dashboard/mensagens/thread'
      preLoaderRoute: typeof DashboardMensagensThreadRouteImport
      parentRoute: typeof DashboardMensagensRoute
    }
    '/dashboard/mensagens/novo': {
      id: '/dashboard/mensagens/novo'
      path: '/novo'
      fullPath: '/dashboard/mensagens/novo'
      preLoaderRoute: typeof DashboardMensagensNovoRouteImport
      parentRoute: typeof DashboardMensagensRoute
    }
    '/admin/terapeutas/$id': {
      id: '/admin/terapeutas/$id'
      path: '/$id'
      fullPath: '/admin/terapeutas/$id'
      preLoaderRoute: typeof AdminTerapeutasIdRouteImport
      parentRoute: typeof AdminTerapeutasRoute
    }
    '/admin/suporte/$userId': {
      id: '/admin/suporte/$userId'
      path: '/$userId'
      fullPath: '/admin/suporte/$userId'
      preLoaderRoute: typeof AdminSuporteUserIdRouteImport
      parentRoute: typeof AdminSuporteRoute
    }
    '/admin/clientes/$id': {
      id: '/admin/clientes/$id'
      path: '/$id'
      fullPath: '/admin/clientes/$id'
      preLoaderRoute: typeof AdminClientesIdRouteImport
      parentRoute: typeof AdminClientesRoute
    }
    '/dashboard/sessoes/recorrencias/': {
      id: '/dashboard/sessoes/recorrencias/'
      path: '/'
      fullPath: '/dashboard/sessoes/recorrencias/'
      preLoaderRoute: typeof DashboardSessoesRecorrenciasIndexRouteImport
      parentRoute: typeof DashboardSessoesRecorrenciasRoute
    }
    '/dashboard/sessoes/recorrencias/$id': {
      id: '/dashboard/sessoes/recorrencias/$id'
      path: '/$id'
      fullPath: '/dashboard/sessoes/recorrencias/$id'
      preLoaderRoute: typeof DashboardSessoesRecorrenciasIdRouteImport
      parentRoute: typeof DashboardSessoesRecorrenciasRoute
    }
    '/dashboard/sessoes/recorrencia/nova': {
      id: '/dashboard/sessoes/recorrencia/nova'
      path: '/recorrencia/nova'
      fullPath: '/dashboard/sessoes/recorrencia/nova'
      preLoaderRoute: typeof DashboardSessoesRecorrenciaNovaRouteImport
      parentRoute: typeof DashboardSessoesRoute
    }
  }
}

interface AdminClientesRouteChildren {
  AdminClientesIdRoute: typeof AdminClientesIdRoute
  AdminClientesIndexRoute: typeof AdminClientesIndexRoute
}

const AdminClientesRouteChildren: AdminClientesRouteChildren = {
  AdminClientesIdRoute: AdminClientesIdRoute,
  AdminClientesIndexRoute: AdminClientesIndexRoute,
}

const AdminClientesRouteWithChildren = AdminClientesRoute._addFileChildren(
  AdminClientesRouteChildren,
)

interface AdminSuporteRouteChildren {
  AdminSuporteUserIdRoute: typeof AdminSuporteUserIdRoute
  AdminSuporteIndexRoute: typeof AdminSuporteIndexRoute
}

const AdminSuporteRouteChildren: AdminSuporteRouteChildren = {
  AdminSuporteUserIdRoute: AdminSuporteUserIdRoute,
  AdminSuporteIndexRoute: AdminSuporteIndexRoute,
}

const AdminSuporteRouteWithChildren = AdminSuporteRoute._addFileChildren(
  AdminSuporteRouteChildren,
)

interface AdminTerapeutasRouteChildren {
  AdminTerapeutasIdRoute: typeof AdminTerapeutasIdRoute
  AdminTerapeutasIndexRoute: typeof AdminTerapeutasIndexRoute
}

const AdminTerapeutasRouteChildren: AdminTerapeutasRouteChildren = {
  AdminTerapeutasIdRoute: AdminTerapeutasIdRoute,
  AdminTerapeutasIndexRoute: AdminTerapeutasIndexRoute,
}

const AdminTerapeutasRouteWithChildren = AdminTerapeutasRoute._addFileChildren(
  AdminTerapeutasRouteChildren,
)

interface AdminRouteChildren {
  AdminAvaliacoesRoute: typeof AdminAvaliacoesRoute
  AdminBiRoute: typeof AdminBiRoute
  AdminCancelamentosRoute: typeof AdminCancelamentosRoute
  AdminClientesRoute: typeof AdminClientesRouteWithChildren
  AdminExtratoRoute: typeof AdminExtratoRoute
  AdminFinanceiroRoute: typeof AdminFinanceiroRoute
  AdminFuncionalidadesRoute: typeof AdminFuncionalidadesRoute
  AdminLeadsRoute: typeof AdminLeadsRoute
  AdminNotasFiscaisRoute: typeof AdminNotasFiscaisRoute
  AdminRepasseRoute: typeof AdminRepasseRoute
  AdminRoadmapRoute: typeof AdminRoadmapRoute
  AdminSessoesRoute: typeof AdminSessoesRoute
  AdminSuporteRoute: typeof AdminSuporteRouteWithChildren
  AdminTerapeutasRoute: typeof AdminTerapeutasRouteWithChildren
  AdminIndexRoute: typeof AdminIndexRoute
}

const AdminRouteChildren: AdminRouteChildren = {
  AdminAvaliacoesRoute: AdminAvaliacoesRoute,
  AdminBiRoute: AdminBiRoute,
  AdminCancelamentosRoute: AdminCancelamentosRoute,
  AdminClientesRoute: AdminClientesRouteWithChildren,
  AdminExtratoRoute: AdminExtratoRoute,
  AdminFinanceiroRoute: AdminFinanceiroRoute,
  AdminFuncionalidadesRoute: AdminFuncionalidadesRoute,
  AdminLeadsRoute: AdminLeadsRoute,
  AdminNotasFiscaisRoute: AdminNotasFiscaisRoute,
  AdminRepasseRoute: AdminRepasseRoute,
  AdminRoadmapRoute: AdminRoadmapRoute,
  AdminSessoesRoute: AdminSessoesRoute,
  AdminSuporteRoute: AdminSuporteRouteWithChildren,
  AdminTerapeutasRoute: AdminTerapeutasRouteWithChildren,
  AdminIndexRoute: AdminIndexRoute,
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)

interface DashboardMensagensRouteChildren {
  DashboardMensagensNovoRoute: typeof DashboardMensagensNovoRoute
  DashboardMensagensThreadRoute: typeof DashboardMensagensThreadRoute
  DashboardMensagensIndexRoute: typeof DashboardMensagensIndexRoute
}

const DashboardMensagensRouteChildren: DashboardMensagensRouteChildren = {
  DashboardMensagensNovoRoute: DashboardMensagensNovoRoute,
  DashboardMensagensThreadRoute: DashboardMensagensThreadRoute,
  DashboardMensagensIndexRoute: DashboardMensagensIndexRoute,
}

const DashboardMensagensRouteWithChildren =
  DashboardMensagensRoute._addFileChildren(DashboardMensagensRouteChildren)

interface DashboardSessoesRecorrenciasRouteChildren {
  DashboardSessoesRecorrenciasIdRoute: typeof DashboardSessoesRecorrenciasIdRoute
  DashboardSessoesRecorrenciasIndexRoute: typeof DashboardSessoesRecorrenciasIndexRoute
}

const DashboardSessoesRecorrenciasRouteChildren: DashboardSessoesRecorrenciasRouteChildren =
  {
    DashboardSessoesRecorrenciasIdRoute: DashboardSessoesRecorrenciasIdRoute,
    DashboardSessoesRecorrenciasIndexRoute:
      DashboardSessoesRecorrenciasIndexRoute,
  }

const DashboardSessoesRecorrenciasRouteWithChildren =
  DashboardSessoesRecorrenciasRoute._addFileChildren(
    DashboardSessoesRecorrenciasRouteChildren,
  )

interface DashboardSessoesRouteChildren {
  DashboardSessoesIdRoute: typeof DashboardSessoesIdRoute
  DashboardSessoesRecorrenciasRoute: typeof DashboardSessoesRecorrenciasRouteWithChildren
  DashboardSessoesIndexRoute: typeof DashboardSessoesIndexRoute
  DashboardSessoesRecorrenciaNovaRoute: typeof DashboardSessoesRecorrenciaNovaRoute
}

const DashboardSessoesRouteChildren: DashboardSessoesRouteChildren = {
  DashboardSessoesIdRoute: DashboardSessoesIdRoute,
  DashboardSessoesRecorrenciasRoute:
    DashboardSessoesRecorrenciasRouteWithChildren,
  DashboardSessoesIndexRoute: DashboardSessoesIndexRoute,
  DashboardSessoesRecorrenciaNovaRoute: DashboardSessoesRecorrenciaNovaRoute,
}

const DashboardSessoesRouteWithChildren =
  DashboardSessoesRoute._addFileChildren(DashboardSessoesRouteChildren)

interface DashboardRouteChildren {
  DashboardAgendaRoute: typeof DashboardAgendaRoute
  DashboardClientesRoute: typeof DashboardClientesRoute
  DashboardContabilidadeRoute: typeof DashboardContabilidadeRoute
  DashboardFinanceiroRoute: typeof DashboardFinanceiroRoute
  DashboardGruposRoute: typeof DashboardGruposRoute
  DashboardIndicacoesRoute: typeof DashboardIndicacoesRoute
  DashboardMensagensRoute: typeof DashboardMensagensRouteWithChildren
  DashboardPerfilRoute: typeof DashboardPerfilRoute
  DashboardPlanoRoute: typeof DashboardPlanoRoute
  DashboardRelatoriosRoute: typeof DashboardRelatoriosRoute
  DashboardSessoesRoute: typeof DashboardSessoesRouteWithChildren
  DashboardIndexRoute: typeof DashboardIndexRoute
  DashboardProntuariosClientIdRoute: typeof DashboardProntuariosClientIdRoute
}

const DashboardRouteChildren: DashboardRouteChildren = {
  DashboardAgendaRoute: DashboardAgendaRoute,
  DashboardClientesRoute: DashboardClientesRoute,
  DashboardContabilidadeRoute: DashboardContabilidadeRoute,
  DashboardFinanceiroRoute: DashboardFinanceiroRoute,
  DashboardGruposRoute: DashboardGruposRoute,
  DashboardIndicacoesRoute: DashboardIndicacoesRoute,
  DashboardMensagensRoute: DashboardMensagensRouteWithChildren,
  DashboardPerfilRoute: DashboardPerfilRoute,
  DashboardPlanoRoute: DashboardPlanoRoute,
  DashboardRelatoriosRoute: DashboardRelatoriosRoute,
  DashboardSessoesRoute: DashboardSessoesRouteWithChildren,
  DashboardIndexRoute: DashboardIndexRoute,
  DashboardProntuariosClientIdRoute: DashboardProntuariosClientIdRoute,
}

const DashboardRouteWithChildren = DashboardRoute._addFileChildren(
  DashboardRouteChildren,
)

interface EspecialidadesRouteChildren {
  EspecialidadesSlugRoute: typeof EspecialidadesSlugRoute
  EspecialidadesIndexRoute: typeof EspecialidadesIndexRoute
}

const EspecialidadesRouteChildren: EspecialidadesRouteChildren = {
  EspecialidadesSlugRoute: EspecialidadesSlugRoute,
  EspecialidadesIndexRoute: EspecialidadesIndexRoute,
}

const EspecialidadesRouteWithChildren = EspecialidadesRoute._addFileChildren(
  EspecialidadesRouteChildren,
)

interface TerapeutasIdRouteChildren {
  TerapeutasIdAgendarRoute: typeof TerapeutasIdAgendarRoute
  TerapeutasIdIndexRoute: typeof TerapeutasIdIndexRoute
}

const TerapeutasIdRouteChildren: TerapeutasIdRouteChildren = {
  TerapeutasIdAgendarRoute: TerapeutasIdAgendarRoute,
  TerapeutasIdIndexRoute: TerapeutasIdIndexRoute,
}

const TerapeutasIdRouteWithChildren = TerapeutasIdRoute._addFileChildren(
  TerapeutasIdRouteChildren,
)

interface TerapeutasRouteChildren {
  TerapeutasIdRoute: typeof TerapeutasIdRouteWithChildren
  TerapeutasIndexRoute: typeof TerapeutasIndexRoute
}

const TerapeutasRouteChildren: TerapeutasRouteChildren = {
  TerapeutasIdRoute: TerapeutasIdRouteWithChildren,
  TerapeutasIndexRoute: TerapeutasIndexRoute,
}

const TerapeutasRouteWithChildren = TerapeutasRoute._addFileChildren(
  TerapeutasRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AdminRoute: AdminRouteWithChildren,
  ComoFuncionaRoute: ComoFuncionaRoute,
  ContabilidadeTerapeutasRoute: ContabilidadeTerapeutasRoute,
  DashboardRoute: DashboardRouteWithChildren,
  EspecialidadesRoute: EspecialidadesRouteWithChildren,
  LoginRoute: LoginRoute,
  ParaTerapeutasRoute: ParaTerapeutasRoute,
  PrivacidadeRoute: PrivacidadeRoute,
  RegisterRoute: RegisterRoute,
  SolucaoRoute: SolucaoRoute,
  TerapeutasRoute: TerapeutasRouteWithChildren,
  TermosRoute: TermosRoute,
  AuthCallbackRoute: AuthCallbackRoute,
  ConviteTokenRoute: ConviteTokenRoute,
  GruposIdRoute: GruposIdRoute,
  OnboardingClientRoute: OnboardingClientRoute,
  OnboardingTherapistRoute: OnboardingTherapistRoute,
  PagamentoPaymentIdRoute: PagamentoPaymentIdRoute,
  SessaoConfirmadaRoute: SessaoConfirmadaRoute,
  SessaoAbrirTokenRoute: SessaoAbrirTokenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
